export function setNotificationsRequest(send) {
  return (sourceAccountId, body, ...args) =>
    send(
      {
        path: '/v1/sourceAccounts/{sourceAccountId}/notifications',
        pathParameters: { sourceAccountId },
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: 'oauth2',
        contentType: 'application/json',
      },
      ...args
    );
}
